import FontFaceObserver from 'fontfaceobserver/fontfaceobserver';

const FONT_FALLBACK_CLASS = 'font-fallback';

export default () => {
    const fontLatoRegular = new FontFaceObserver('Lato');
    const fontLatoBold = new FontFaceObserver('Lato', {
        style: 'bold'
    });

    const fontNeoTechRegular = new FontFaceObserver('Neo Tech W01');
    const fontNeoTechBold = new FontFaceObserver('Neo Tech W01', {
        style: 'bold'
    });

    Promise.all([fontLatoRegular.load(), fontLatoBold.load(), fontNeoTechRegular.load(), fontNeoTechBold.load()]).catch(
        () => {
            document.documentElement.classList.add(FONT_FALLBACK_CLASS);
        }
    );
};
